import pageConfig from '@/baseData/outInStoreRecord/manageList'
import { getOutInListSensitive } from '@/api/carManage'

export default function () {
  const { configData } = pageConfig.call(this, { dealWithData: this.dealWithData })
  configData.tableData.apiFn = getOutInListSensitive
  const operateColumn = {
    name: 'operate',
    columnProps: {
      label: '操作',
      fixed: 'right',
    },
    type: 'operate',
    getOperateList: ({ row }) => {
      const detail = [{
        name: 'operate1', label: '详情', action: () => this.goOutInDetails(row),
      }]
      return detail
    },
  }
  configData.isShowDepartment = false
  configData.tableData.columns.push(operateColumn)
  configData.formData.exportData = {
    exportTemplate: 'CarOutInList',
    filename: '出入库管理.xlsx',
    permissionName: 'vehicle_list_detail',
  }
  return {
    configData,
  }
}

